/**
 * Homestead feature flags. Registered with Backstage in modules/feature-flags and
 * listed automatically under Settings → Feature Flags.
 *
 * Backstage flags are off by default and stored per browser, so each flag is named
 * for the non-default behavior it turns on.
 */
export const homesteadFeatureFlags = [
  {
    name: 'scaffolder-streaming-logs',
    description:
      'Stream scaffolder task logs over a persistent connection instead of polling over HTTP. Off by default because streaming hits intermittent "network error" behind some proxies.',
  },
] as const satisfies readonly { name: string; description: string }[];

export type HomesteadFeatureFlagName =
  (typeof homesteadFeatureFlags)[number]['name'];
